import React from 'react';
import { useSearchParams } from 'react-router-dom';

import IndexPaginationNav from '@buyside/components/presentation/IndexPaginationNav/indexPaginationNav';
import JobApplicationIndexCard from '@buyside/components/presentation/JobApplicationIndexPage/IndexCard/JobApplicationIndexCard';
import JobApplicationIndexPageHeader from '@buyside/components/presentation/JobApplicationIndexPage/Header/JobApplicationIndexPageHeader';
import LoadingSpinner, {
  SIZES
} from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';

import { useJobApplicationIndexListQuery } from '@interfaces/graphql-typings';

import { validatePageParam } from '@buyside/util/numbers';

import styles from './jobApplicationIndexPageStyles.scss';

const JobApplicationIndexPage: React.FC<{ jobPostingId: string; jobPostingTitle: string }> = ({
  jobPostingId,
  jobPostingTitle
}) => {
  const [searchParams] = useSearchParams();
  validatePageParam(searchParams);
  searchParams.set('job_posting_id', jobPostingId);

  const { data, loading, error } = useJobApplicationIndexListQuery({
    variables: { searchParams: searchParams.toString() }
  });

  return (
    <main className={styles.container}>
      <JobApplicationIndexPageHeader
        jobPostingId={jobPostingId}
        resultCount={data?.indexListResultCount || 0}
        title={jobPostingTitle}
      />
      {error && <div className={styles.error}>{error.message}</div>}
      {loading ? (
        <LoadingSpinner size={SIZES.LARGE} />
      ) : (
        <div className={styles.indexList}>
          {data?.jobApplicationsIndexList &&
            data?.jobApplicationsIndexList.map(
              ({
                coverNote,
                createdAt,
                email,
                id,
                name,
                phone,
                resumeUrl,
                starred,
                status,
                user
              }) => {
                if (!user) return null;
                const { mostRecentEmployer, profile, userBadges } = user;

                return (
                  <div key={id}>
                    <JobApplicationIndexCard
                      applicantCity={profile?.city || null}
                      applicantEmployerId={mostRecentEmployer?.employer?.id || null}
                      applicantEmployerName={mostRecentEmployer?.employer?.name || null}
                      applicantRecentEmployerTitle={mostRecentEmployer?.title || null}
                      coverNote={coverNote}
                      createdAt={createdAt}
                      email={email}
                      hasBadges={Boolean(userBadges?.edges?.length)}
                      isApplicantCurrentlyEmployed={Boolean(mostRecentEmployer?.currentEmployer)}
                      jobApplicationId={id}
                      jobPostingId={jobPostingId}
                      jobPostingTitle={jobPostingTitle}
                      name={name}
                      phone={phone}
                      profileImageUrl={profile?.imageProfileUrl || null}
                      profileSummary={profile?.summary || null}
                      publishedIdeasCount={user?.publishedIdeasCount}
                      resumeUrl={resumeUrl}
                      starred={Boolean(starred)}
                      status={status}
                      userBadges={userBadges?.edges}
                      userId={user?.id}
                    />
                  </div>
                );
              }
            )}
        </div>
      )}
      <div className={styles.paginationNav}>
        <h6 className={styles.responsiveNavPageTitle}>PAGES</h6>
        <IndexPaginationNav
          resultCount={data?.indexListResultCount || 0}
          resultLength={data?.jobApplicationsIndexList?.length || 0}
          resultsPerPage={10}
        />
      </div>
    </main>
  );
};
export default JobApplicationIndexPage;
